import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import {getBaseURL} from "../src/utils"


const baseQuery = fetchBaseQuery({
    baseUrl: getBaseURL(),
    prepareHeaders: (headers, { getState }) => {
        // @ts-ignore
        const { auth: { token } } = getState()
        if(token)
            headers.append('authorization', `Token ${token}`)
        return headers;
    }
})

const apiSlice = createApi({
    reducerPath: 'api',
    baseQuery,
    endpoints: () => ({}),
    tagTypes: ["user", "leave"],
})

export default apiSlice;